import { createRESTStore } from "@stores/shared/createRESTStore";
import apiClient from "@services/api/apiClient";
import API from "@config/shared/api-paths";

// Status counts for the dashboard Accreditation widget.
// GET /client/accreditation/counts → { valid, expiring, expired, noExpiry }.
// Every Member sees the widget in the list, but only accreditors (Manager+,
// the Accreditor role, or the configured accreditor group) may read the
// counts — the endpoint answers 403 otherwise, and the widget is hidden.
// Same TTL cache as the widget rolodex so remounts don't refetch.
const CACHE_TTL = 5 * 60 * 1000;

const useAccreditationWidgetStore = createRESTStore({
  entityName: "accreditationWidget",
  apiPaths: {
    fetch: `${API.BASE}${API.FRONTEND.ACCREDITATION}/counts`,
  },
  initialState: null,

  additionalActions: (set, get) => ({
    counts: null,
    forbidden: false,
    countsFailed: false,
    fetchingCounts: false,
    countsFetchedAt: 0,

    fetchCounts: async (forceRefresh = false) => {
      const { counts, countsFetchedAt, forbidden, fetchingCounts } = get();
      if (fetchingCounts) return;
      if (
        !forceRefresh &&
        (forbidden || (counts && Date.now() - countsFetchedAt < CACHE_TTL))
      )
        return;

      set({ fetchingCounts: true, countsFailed: false });
      try {
        const { data } = await apiClient.get(get().apiPaths.fetch);
        set({
          counts: data,
          forbidden: false,
          fetchingCounts: false,
          countsFetchedAt: Date.now(),
        });
      } catch (error) {
        const forbidden = error?.status === 403;
        set({ fetchingCounts: false, forbidden, countsFailed: !forbidden });
        if (!forbidden) console.error(error);
      }
    },
  }),
});

export default useAccreditationWidgetStore;
